'use client'

import Image from 'next/image'

type Props = {
  t: (key: string) => string
  lp?: string
}

const WHO_CARDS = [
  {
    titleKey: 'landing.arWho1Title',
    descKey: 'landing.arWho1Desc',
    src: '/images/who/fast-food.png',
    alt: 'Busy fast food and takeaway counter',
  },
  {
    titleKey: 'landing.arWho2Title',
    descKey: 'landing.arWho2Desc',
    src: '/images/who/cafe.png',
    alt: 'Cafe counter with coffee and pastries',
  },
  {
    titleKey: 'landing.arWho3Title',
    descKey: 'landing.arWho3Desc',
    src: '/images/who/multi-branch.png',
    alt: 'Restaurant dining room for multi-branch groups',
  },
] as const

/** Static i18n marketing tail (guarantees / who) — no CMS fetch. */
export default function LandingBelowFoldStatic({ t }: Props) {
  return (
    <>
      <section className="ar-guarantees" aria-labelledby="ar-guarantees-heading">
        <div className="ar-container">
          <h2 id="ar-guarantees-heading" className="ar-guarantees-title">
            {t('landing.guaranteeTitle')}
          </h2>
          <div className="ar-guarantees-grid">
            <div className="ar-guarantee-card">
              <h3 className="ar-guarantee-card-title">{t('landing.guarantee1Title')}</h3>
              <p className="ar-guarantee-card-desc">{t('landing.guarantee1Desc')}</p>
            </div>
            <div className="ar-guarantee-card">
              <h3 className="ar-guarantee-card-title">{t('landing.guarantee2Title')}</h3>
              <p className="ar-guarantee-card-desc">{t('landing.guarantee2Desc')}</p>
            </div>
            <div className="ar-guarantee-card">
              <h3 className="ar-guarantee-card-title">{t('landing.guarantee3Title')}</h3>
              <p className="ar-guarantee-card-desc">{t('landing.guarantee3Desc')}</p>
            </div>
            <div className="ar-guarantee-card">
              <h3 className="ar-guarantee-card-title">{t('landing.guarantee4Title')}</h3>
              <p className="ar-guarantee-card-desc">{t('landing.guarantee4Desc')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="ar-who" aria-labelledby="ar-who-heading">
        <div className="ar-container">
          <h2 id="ar-who-heading" className="ar-who-title">
            {t('landing.arWhoTitle')}
          </h2>
          <div className="ar-who-grid">
            {WHO_CARDS.map((card) => (
              <div key={card.src} className="ar-who-card">
                <div className="ar-who-img">
                  <Image
                    src={card.src}
                    alt={card.alt}
                    fill
                    sizes="(max-width: 900px) 100vw, 33vw"
                    style={{ objectFit: 'cover' }}
                  />
                </div>
                <h3 className="ar-who-card-title">{t(card.titleKey)}</h3>
                <p className="ar-who-card-desc">{t(card.descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
